<template>
  <div
    class="top_list_wrap dp_fs_color"
    :class="{yincang_active: chunjing}"
  >
    <div class="top_list_ul_left">
      <div
        class="top_list_li"
        @click="showLayer(3)"
      >
        <div class="top_list_text_wrap">
          <p class="top_tit">
            当前预警数
          </p>
          <div class="top_sum yujing_sum default_color"></div>
        </div>
        <!--        <img :src="quanImg" alt="">-->
      </div>
      <div
        class="top_list_li"
        @click="showLayer(0)"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      >
        <div class="top_list_text_wrap">
          <p class="top_tit">
            安全指数
          </p>
          <div class="top_sum wanhao_sum default_color"></div>
        </div>
        <!--        <img :src="quanImg" alt="">-->
      </div>
    </div>
    <div
      v-if="calculate"
      class="explain common-layer"
    >
      <div class="left">
        <p>
          昨日安全指数=
        </p>
      </div>
      <div class="right">
        <p>
          单位昨日安全指数之和
        </p>
        <p class="line"></p>
        <p>
          单位总数
        </p>
      </div>
    </div>
    <div
      class="industry_img"
      @click.stop="switchFn"
    >
      <span
        class="industry_span"
        :title=" industry "
      >{{ industry }}</span>
      <ul v-show="sho">
        <li
          @click.stop="industryFn(item.name,item.value)"
          v-for="(item,index) in industryLsit"
          :key="index"
        >{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import quanImg from "@/assets/img/quan.png";

export default {
  name: "",
  data: () => ({
    quanImg: quanImg,
    calculate: false,
    warnCount: 0,
    industryLsit: [], // 行业接口数据
    sho: false, // 元素显示隐藏
    industry: "行业", // 行业内容
  }),
  props: ["chunjing", "topDate"],
  watch: {
    topDate: {
      handler(res, oldVal) {
        if (res) {
          //获取数据
          if (res[0] && res[0] != "") {
            //res[0] 左侧数据
            let leftNum = JSON.parse(res[0]).score;
            this.allSumInit(Math.round(leftNum), "wanhao_sum", "wh_sum_box");
          }

          if (Object.keys(res[1]).length) {
            if (res[1].warnCount != null && res[1].warnCount != undefined) {
              this.allSumInit(
                Math.abs(res[1].warnCount),
                "yujing_sum",
                "yj_sum_box"
              );
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {},
  created() {},
  computed: {},
  mounted() {
    this.getIndustData();
  },
  methods: {
    // 行业接口数据
    getIndustData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/industryCategory/data",
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        // console.log("1111111---", res.data.data);
        if (res.data.success && res.data.data.length) {
          res.data.data.unshift({
            name: "全部",
            value: null,
          });
          this.industryLsit = res.data.data;
        }
      });
    },

    //  内容切换显示隐藏
    switchFn() {
      this.sho = !this.sho;
    },
    // 给标签赋值 然后调用地图接口数据刷新
    industryFn(data, value) {
      // console.log("value----", value);
      this.$emit("mapInterface", value);
      this.industry = data;
      this.sho = !this.sho;
    },

    showLayer(index) {
      //顶部4个圆点击，显示弹窗
      let obj = {
        status: true,
        type: "midTop" + index,
      };
      console.log(obj);
      this.$store.commit("showLayer", obj);
    },
    allSumInit(data, parentName, childName) {
      //思路
      //首先初始化，每一个数字都是ul里面包含了10个数字,分割字符串，用li包裹
      //传入值，针对每一个进行动画滚动,每一个数字高度为40px
      let res = String(data).split("");
      this.sumInit(res, parentName, childName);
      for (let i = 0; i < res.length; i++) {
        let gundongSum = -res[i] * 40 + "px";
        $(
          "." + parentName + " .sum_wrap:nth-child(" + parseInt(i + 1) + ")"
        ).show();
        this.$nextTick(() => {
          $("." + parentName + " .sum_wrap:nth-child(" + parseInt(i + 1) + ")")
            .find("ul")
            .css("transform", "translateY(" + gundongSum + ")");
        });
      }
    },
    sumInit(data, parent, child) {
      if ($("." + child).length != data.length) {
        $("." + parent)
          .find(".sum_wrap")
          .remove();
        for (let i = 0; i < data.length; i++) {
          let html = `<div class="sum_wrap ${child}"><ul>
            <li>0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>7</li>
            <li>8</li>
            <li>9</li>
          </ul></div>`;
          $("." + parent).prepend(html);
        }
        $("." + parent)
          .find(".sum_wrap")
          .hide();
      }
    },
    mouseOver() {
      this.calculate = true;
    },
    mouseLeave() {
      this.calculate = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.industry_img {
  cursor: pointer;
  width: 120px;
  height: 36px;
  padding-top: 6px;
  position: absolute;
  top: 10px;
  right: -140px;
  background-image: url("../assets/img/hy.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .industry_span {
    width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    text-align: left;
    margin-left: 20px;
    color: #fff;
  }
  ul {
    overflow: auto;
    margin-top: 12px;
    border-radius: 6%;
    width: 260px;
    height: 200px;
    background: #06122c;
    li {
      text-align: left;
      margin-left: 20px;
      line-height: 30px;
      color: #fff;
    }
    li:hover {
      color: #74d9ff;
    }
  }
}
.top_list_wrap {
  position: absolute;
  top: 140px;
  left: 500px;
  //width: calc(100% - 1000px);
  transition: all 1s;
  transform: translateY(0);
  text-align: center;
  z-index: 10;
  //.top_list_ul{
  //  display: flex;
  //  justify-content: space-around;
  //}
  .top_list_ul_left {
    /*width: 155px;*/
    position: relative;
  }
  .top_list_li {
    //flex: 1;
    //flex-shrink: 0;
    //overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;

    .top_list_text_wrap {
      z-index: 2;
      height: 78px;
      /*width: 155px;*/
      /*height: 160px;*/
      /*position: absolute;*/
      /*left: 0;*/
      margin-left: 0;
      display: -webkit-box;
      /*! autoprefixer: off*/
      -webkit-box-orient: vertical;
      /* autoprefixer: on*/
      -webkit-box-align: center;
      //-webkit-box-pack: center;
      background-image: url("../assets/img/quan.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 0 20px;
      .top_tit {
        font-size: 16px;
        margin-bottom: 10px;
        position: relative;
        bottom: 10px;
      }
      .top_sum {
        font-size: 28px;
        overflow: hidden;
      }
    }
  }
  //@keyframes move {
  //  0%{transform: rotate(0deg)}
  //  100%{transform: rotate(360deg)}
  //}
}
.yincang_active {
  transform: translateY(-200%);
}
.explain {
  display: flex;
  color: #74d9ff;
  position: absolute;
  left: 5%;
  background: #06122c;
  top: 200px;
  width: 400px;
  height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  // border: 1px solid var(--common-block-border);
  border-radius: 5px;
  z-index: 1;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  .left {
    width: 110px;
    text-align: left;
  }
  .right {
    width: 270px;
    text-align: center;
    float: right;
  }
  .line {
    width: 100%;
    height: 2px;
    background: #74d9ff;
    // background: var(--mod-part-line);
    margin: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topLeftList.vue